<lib-preloader [loading]="isLoading"></lib-preloader>
<ng-container *ngIf="isReady">
    <lib-technical-check
            [config]="config?.techCheckConfig"
            [isEng]="isEng"
            [gazefilter]="gazefilter"
            [isWasmConfigLoaded]="isWasmConfigLoaded"
            *ngIf=" !isChecked" (checked)="onChecked($event)">
    </lib-technical-check>
    <lib-calibration
            [isEng]="isEng"
            [config]="config?.calibConfig"
            [gazefilter]="gazefilter" *ngIf="isChecked && !isCalibrated"
            (calibrated)="onCalibrated($event)"
            (calibrationStarted)="onCalibrationStarted($event)"
            (errorEvent)="onError('calibration')"
    ></lib-calibration>
    <lib-visual-test
            [environment]="environment"
            [isEng]="isEng"
            [testId]="testId"
            [sid]="sid"
            [uid]="uid"
            [config]="config.visualTest"
            [stopTestConfig]="config?.stopTestConfig"
            [gazefilter]="gazefilter"
            *ngIf="!isLoading && isChecked && isCalibrated"
            (testEnd)="onTestEnd($event)"
            (errorEvent)="onError('test')"
    ></lib-visual-test>

    <!--  <lib-slide-1 *ngIf="isChecked && isCalibrated"-->
    <!--  ></lib-slide-1>-->
</ng-container>
